import get from 'lodash/get';
import set from 'lodash/set';

const getDirtyValues = ({ dirtyFields, values }) => Object.keys(dirtyFields).reduce((acc, path) => {
    set(acc, path, get(values, path));
    return acc;
}, {});

export default getDirtyValues;
